import React, { memo } from 'react';
import { View, TextInput, TouchableOpacity, StyleSheet } from 'react-native';
import { SEMANTIC_COLORS, PRIMITIVE_COLORS } from '@/constants/residents/residentColors';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { CORK_BOARD_INPUT_LIMITS } from '@/constants/residents/corkBoardConstants';

interface CorkBoardSearchBarProps {
  value: string;
  onChangeText: (text: string) => void;
  onClear: () => void;
}

export const CorkBoardSearchBar: React.FC<CorkBoardSearchBarProps> = memo(({
  value,
  onChangeText,
  onClear,
}) => {
  return (
    <View style={styles.container}>
      <RESIDENTS_SVG_COMPONENTS.MAGNIFYING_GLASS width={16} height={16} color={SEMANTIC_COLORS.text.muted} />
      <TextInput
        style={styles.input}
        value={value}
        onChangeText={onChangeText}
        placeholder="Search posts..."
        placeholderTextColor={SEMANTIC_COLORS.text.muted}
        maxLength={CORK_BOARD_INPUT_LIMITS.searchMax}
        returnKeyType="search"
        autoCapitalize="none"
        autoCorrect={false}
        accessibilityLabel="Search community board posts"
        accessibilityRole="search"
      />
      {value.length > 0 && (
        <TouchableOpacity
          style={styles.clearButton}
          onPress={onClear}
          activeOpacity={0.7}
          accessibilityRole="button"
          accessibilityLabel="Clear search"
        >
          <RESIDENTS_SVG_COMPONENTS.CANCEL_X width={14} height={14} color={SEMANTIC_COLORS.text.muted} />
        </TouchableOpacity>
      )}
    </View>
  );
});

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: PRIMITIVE_COLORS.gray850,
    borderRadius: 10,
    paddingHorizontal: 12,
    height: 40,
    gap: 8,
  },
  input: {
    flex: 1,
    fontSize: 14,
    color: SEMANTIC_COLORS.text.primary,
    paddingVertical: 0,
  },
  clearButton: {
    padding: 4,
  },
});
